import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { Component } from 'react'

export default class Collapsible extends Component {
    constructor(props) {
        super(props)

        this.bodyRef = React.createRef()
        this.state = {
            isOpen: typeof this.props?.defaultOpen === 'boolean' ? this.props.defaultOpen : false,
            height: 0,
            maxHeight: props.maxHeight || 350,
        }
    }

    componentDidMount() {
        this.resizeObserver = new ResizeObserver(() => {
            if (this.bodyRef && this.state.isOpen) {
                this.setState({
                    height: this.bodyRef.current?.getBoundingClientRect()?.height
                })
            }
        });

        this.resizeObserver.observe(this.bodyRef.current);
    }

    componentDidUpdate(_, prevState) {
        if (prevState.isOpen !== this.state.isOpen) {
            if (this.bodyRef) {
                this.setState({
                    height: this.bodyRef.current?.getBoundingClientRect()?.height
                })
            }
        }
    }

    componentWillUnmount() {
        this.resizeObserver.disconnect()
    }

    toggleOpen = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    getCollapsibleStyle() {
        let height = '0px'

        if (this.state.isOpen) {
            height = `${this.state.height}px`
        }
        
        return {
            maxHeight: height,
        }
    }

    toggleIcon = () => {
        return <FontAwesomeIcon 
            icon={faChevronDown} 
            className={`text-2xl transition-transform duration-200 transform ${this.state.isOpen ? 'rotate-180' : 'rotate-0'}`}
        />
    }

    render() {
        const collapsibleStyle = this.getCollapsibleStyle()
        
        return (
            <div className={`collapsible bg-white-7 px-4 py-4 shadow-md rounded-md w-full ${this.props.className || ''}`}>
                <div className="py-2 pb-0 mb-2 flex justify-between items-center cursor-pointer select-none" onClick={this.toggleOpen}>
                    <div>
                        <h5 className="text-xl font-bold mb-1">{this.props.title}</h5>
                        <p className="text-sm" style={{ color: '#818181' }}>{this.props.subTitle}</p>
                    </div>
                    <div className="icon-arrow ml-4">
                        {this.toggleIcon()}
                    </div>
                </div>
                <div className="collapsible-body overflow-hidden transition-all duration-200" style={collapsibleStyle} >
                    <div className="overflow-auto" style={{ maxHeight: `${this.state.maxHeight}px` }} ref={this.bodyRef}>
                        { this.props.children }
                    </div>
                </div>
            </div>
        )
    }
}
